import { useCallback } from 'react';

import { useAuthStore } from '@@scripts/store/useAuthStore';
import { useDevToolbarSmartUserRole } from '@@scripts/store/useDevToolbarStore';

import { ROLES, type UserRole } from '../constants';

const useAuthorization = () => {
    const currentUserRole = useDevToolbarSmartUserRole();
    const authUserRole = useAuthStore((state) => state.userRole);

    const userRole = currentUserRole || authUserRole;

    const isAuthorized = useCallback(
        (userRoles: UserRole[] | undefined) =>
            !userRoles ||
            (userRole && userRoles.includes(userRole)) ||
            userRoles.includes(ROLES.EDITOR),
        [userRole],
    );

    // check role authorization, authorize everyone if no authorize is supplied
    return { isAuthorized };
};

export default useAuthorization;
